import React from 'react';
import { connect } from 'react-redux';
import TopComponent from '../components/header/TopComponent';
import MenuComponent from '../components/header/MenuComponent';
import { getHeader } from '../store/header/action';
import ReactGA from 'react-ga4';

class HeaderContainer extends React.Component {

  constructor(props) {
    super(props);     
    
    this.menuClicked = this.menuClicked.bind(this)
  }
  /**
   * @method componentDidMount
   * to load the data after state changed
   */
  componentDidMount() {
    this.props.getHeader();  
  }

  menuClicked(eventLabel) {
    ReactGA.event('Click', {
      category: 'Navigate',
      action: 'Click',
      event_category: 'Navigate',
      event_action: 'Click',
      event_label: eventLabel,
      UserID: (this.props.auth.auth.userId) ?  this.props.auth.auth.userId : 'noAuth'
    });
  }

  render() {
    if(this.props.auth && this.props.auth.auth && this.props.auth.auth.isAppHeader)
    {
      return (
        <React.Fragment>
          <MenuComponent menus={this.props.header.menus} menuClicked={this.menuClicked} />
        </React.Fragment>
    )
    }
    else
    {
    return ( 
        <React.Fragment>
          <TopComponent top={this.props.header.top} />
          <MenuComponent menus={this.props.header.menus} menuClicked={this.menuClicked} />
        </React.Fragment>        
    )
    }
  }

}
//export default HeaderContainer;

/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  getHeader: getHeader
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  header: state.headerReducer,
  auth: state.auth
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderContainer);
